import type { CheckboxProps } from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import type { ReactNode } from 'react'

import HyCheckbox from './hy/HyCheckbox'

type LabeledCheckboxProps = {
  label: ReactNode
} & CheckboxProps

const LabeledCheckbox = ({ label, ...checkboxProps }: LabeledCheckboxProps) => {
  return <FormControlLabel control={<HyCheckbox {...checkboxProps} />} label={label} sx={{ cursor: 'default' }} />
}

export default LabeledCheckbox
